<template>
  <div>
    <v-scale-transition>
      <v-overlay v-show="booths.length == 0" opacity="1">
        <loading></loading>
      </v-overlay>
    </v-scale-transition>
    <v-col cols="12" style="justify-content: center; padding: 0px 12px 0 12px">
      <v-toolbar-items>
        <v-text-field
          elevation="2"
          solo
          placeholder="جستجو"
          style="font-weight: 800; border-radius: 0px 50px 50px 0px"
          v-model="search"
          hide-details
          @input="listboothssearch"
          :input.sync="search"
        />
        <v-select
          elevation="2"
          append-icon="mdi-map-marker"
          style="max-width: 150px; border-radius: 50px 0px 0px 50px"
          :items="select_items"
          item-text="title"
          item-value="id"
          hide-details
          label="انتخاب شهر"
          solo
        ></v-select>
      </v-toolbar-items>
    </v-col>

    <v-row class="ma-4 show">
      <v-icon style="rotate: 180deg">mdi-sort</v-icon>
      <h4 class="mt-4">مرتب سازی:</h4>
      <v-chip-group active-class="red--text">
        <v-chip
          v-for="item in items"
          @click="clicksort(item.title)"
          :key="item.id"
          color="transparent"
          link
        >
          <strong :color="item.color">
            {{ item.title }}
          </strong>
        </v-chip>
      </v-chip-group>
    </v-row>
    <v-divider class="show"></v-divider>
    <!-- <v-row
      class="mt-1"
      style="
        margin: 0;
        justify-content: center;
        padding-left: 0;
        padding-right: 0;
      "
    > -->
    <div class="text-center">
      <v-overlay :value="overlay">
        <div id="preloader" class="blobs-wrapper">
          <div id="status" class="ttm-bgcolor-skincolor loader-blob"></div></div
      ></v-overlay>
    </div>
    <v-row class="ma-0">
      <v-col style="padding: 6px" cols="12" md="3" sm="6">
        <v-sheet
          v-for="(item, index) in booths"
          :key="'sceleton' + index"
          :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
          class="pa-2"
          v-show="firstLoad"
        >
          <v-skeleton-loader
            height="350"
            max-height="315"
            type="image, article"
          ></v-skeleton-loader>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col
        style="padding: 6px"
        v-for="(item, index) in booths"
        :key="index"
        cols="12"
        md="3"
        sm="6"
      >
        <v-card
          hover
          v-show="!firstLoad"
          class="img-wrapper"
          height="350"
          max-height="315"
        >
          <router-link
            style="text-decoration: none"
            :to="{
              name: 'customertemplate',
              params: { name: item.url, ID: item.id },
            }"
          >
            <picture>
              <source type="image/webp" :srcset="item.image" />
              <v-img
                class="inner-img"
                height="150"
                :src="item.image"
                :alt="item.name"
              >
              </v-img>
            </picture>
          </router-link>
          <v-card
            class="top-avatar"
            align="center"
            elevation="0"
            color="transparent"
          >
            <v-card-text class="justify">
              <picture>
                <source type="image/webp" :srcset="item.image" />
                <v-avatar
                  style="border: 2px solid white"
                  height="70"
                  width="70"
                  rounded
                >
                  <v-img class="inner-img" :src="item.image" :alt="item.name" />
                </v-avatar>
              </picture>
            </v-card-text>
          </v-card>
          <router-link
            style="text-decoration: none; color: grey"
            :to="{
              name: 'customertemplate',
              params: { name: item.url, ID: item.id },
            }"
          >
            <h5
              class="px-2"
              style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                text-align: center;
                font-weight: 800;
              "
            >
              {{ item.name }}
              <v-icon v-show="item.blueTick == 1" size="15" color="blue"
                >mdi-check-decagram</v-icon
              >
            </h5>
          </router-link>
          <v-card-title style="font-size: 12px" align="center">
            <v-rating
              size="20"
              background-color="orange lighten-3"
              color="orange"
              :length="1"
              :value="1"
            >
            </v-rating>
            {{ item.star.toFixed(1) }} , {{ item.votes }}
          </v-card-title>
          <v-card-actions>
            <v-row style="justify-content: flex-start" align="center">
              <v-col cols="5">
                <v-btn
                  @click="
                    [item.isFollow == false ? follow(item) : unfollow(item)]
                  "
                  small
                  width="95px"
                  :color="item.isFollow == true ? 'primary' : 'success'"
                  rounded
                  v-text="
                    item.isFollow == false ? 'دنبال کردن' : 'دنبال می شود'
                  "
                ></v-btn>
              </v-col>
              <v-col cols="1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <router-link
                      style="text-decoration: none"
                      :to="{
                        name: 'customertemplate',
                        params: { name: item.url, ID: item.id },
                        props: { id: item.id },
                      }"
                    >
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        fab
                        dark
                        x-small
                        color="success"
                        ><v-icon>mdi-map-marker</v-icon></v-btn
                      >
                    </router-link>
                  </template>
                  <span>نشانی</span>
                </v-tooltip>
              </v-col>
              <v-col cols="1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <!-- <router-link
                      style="text-decoration: none"
                      :to="'tel:' + item.whatsapp"
                    > -->
                    <v-btn
                      v-bind="attrs"
                      style="text-decoration: none"
                      v-on="on"
                      fab
                      dark
                      x-small
                      color="success"
                      id="mobile"
                      :href="'tel:' + item.whatsapp"
                      ><v-icon>mdi-phone</v-icon></v-btn
                    >
                    <!-- </router-link> -->
                  </template>
                  <span>اطلاعات تماس</span>
                </v-tooltip>
              </v-col>
              <v-col cols="1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div class="p-4">
                      <v-speed-dial
                        v-bind="attrs"
                        v-on="on"
                        fab
                        dark
                        x-small
                        :transition="transition"
                      >
                        <template v-slot:activator>
                          <v-btn fab dark x-small color="success">
                            <v-icon> mdi-square-rounded-badge </v-icon>
                          </v-btn>
                        </template>
                        <v-btn
                          rel="noopener noreferrer"
                          target="_blank"
                          :href="
                            'https://wa.me/' +
                            item.whatsapp +
                            '/?text=urlencodedtext'
                          "
                          fab
                          dark
                          x-small
                          color="green"
                        >
                          <v-icon>mdi-whatsapp</v-icon>
                        </v-btn>
                        <v-btn
                          rel="noopener noreferrer"
                          target="_blank"
                          :href="'https://www.instagram.com/' + item.instagram"
                          fab
                          dark
                          x-small
                          color="red"
                        >
                          <v-icon>mdi-instagram</v-icon>
                        </v-btn>
                      </v-speed-dial>
                    </div>
                  </template>
                  <span>سوشیال مدیا</span>
                </v-tooltip>
              </v-col>
              <v-col class="pr-1" cols="1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      disabled
                      width="48"
                      height="48"
                      v-bind="attrs"
                      v-on="on"
                      text
                      href=""
                      style="justify-content: end"
                    >
                      <picture>
                        <source
                          type="image/png"
                          srcset="@/assets/images/360-degrees.png" />
                        <v-img
                          width="24"
                          style="
                            background-size: auto !important;
                            border-radius: 0px !important;
                          "
                          class="rounded"
                          src="@/assets/images/360-degrees.png"
                          v-show="item.havePanorama == true"
                          :alt="'panaroma' + item.name" /></picture
                    ></v-btn>
                  </template>
                  <span>تور مجازی</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <div class="text-center mt-3" v-if="current_page >= 4" style="margin: auto">
      <v-pagination
        @input="[listbooths(current_page), (overlay = !overlay)]"
        v-model="current_page"
        :length="last_page"
        :total-visible="7"
        circle
      ></v-pagination>
    </div>
    <div v-if="booths.length" v-observe-visibility="handleScrolledBottom"></div>
    <!-- </v-row> -->
  </div>
</template>

<script>
import loading from "@/layouts/loading_main_namya.vue";
export default {
  // metaInfo: {
  //   // title will be injected into parent titleTemplate
  //   titleTemplate: "%s | کسب و کار ها",
  // },
  props: {
    category: {
      type: Number,
    },
    sort: {
      type: String,
    },
    ID: {
      type: String,
    },
  },
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  components: {
    loading,
  },
  data() {
    return {
      current_page: 1,
      last_page: 1,
      isActive: false,
      // show: false,
      click: false,
      transition: "scale-transition",
      hover: true,
      direction: "top",
      loading: false,
      firstLoad: true,
      booths: [],
      boothsSearch: [],
      domainID: "",
      overlay: false,
      isFollow: false,
      search: "",
      form: {
        business: "",
      },
      sortclick: "",
      items: [
        {
          id: 1,
          title: "مرتبط ترین",
          color: "red",
          //defualt
        },
        {
          id: 2,
          title: "بالاترین رتبه",
          color: "red",
          //rank
        },
        {
          id: 3,
          title: "جدیدترین",
          image: "mdi-new-box",
          color: "red",
          //newest
        },
        {
          id: 4,
          title: "بیشترین بازدید",
          color: "red",
          //view
        },
        {
          id: 5,
          title: "بالاترین امتیاز",
          color: "red",
          //Rank
        },
        {
          id: 6,
          title: "نزدیک ترین",
          color: "red",
          //near
        },
      ],
      select_items: [
        { id: 1, title: "یزد" },
        { id: 2, title: "تهران" },
        { id: 3, title: "تبریز" },
      ],

      location: window.document.location.host.replace("www.", ""),
    };
  },
  watch: {
    testProp() {
      // here was the mistake
      this.stored_data = this.testProp;
    },
    top(val) {
      this.bottom = !val;
    },
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false;
        }, 2500);
    },
  },
  mounted() {
    setTimeout(() => (this.firstLoad = false), 2000);
  },
  methods: {
    reserve() {
      this.loading = true;
      setTimeout(() => (this.loading = false), 500);
    },
    // clicks() {
    //   var self = this;
    //   for (let intCntr = 0; intCntr < self.items.length; intCntr++) {
    //     self.items[intCntr].ExploreState = false;
    //     if (self.items[intCntr].ExploreState == false) {
    //       (self.items[intCntr].ExploreState = true), (self.show = true);
    //     } else {
    //       (self.items[intCntr].ExploreState = false), (self.show = false);
    //     }
    //   }
    // },
    async RedirectDomain() {
      let Return = null;
      if (this.domainID == "" && this.location != "namya.app") {
        let response = await this.axios
          .get(
            "https://namya.ir/api/v1/domain/" + this.location, //domain necessary
            {
              headers: {
                "access-control-allow-headers":
                  "'access-control-allow-methods','access-control-allow-origin'",
                "access-control-allow-methods":
                  "PUT, GET, HEAD, POST, DELETE, OPTIONS",
                "access-control-allow-origin": "*",
              },
            }
          )
          .then((response) => {
            this.domainID = response.data.data;
            // Return = {
            //   ID: this.domainID,
            // };
            // this.$emit("ID", Return);
            this.$router.push({ name: "customertemplate" }).catch();
          })
          .catch(() => {});
      }
    },
    clickbooth(item) {
      this.domainID = item.id;
      localStorage.setItem("ID", JSON.stringify(item.id));
      this.$router.push({ name: "customertemplate" }).catch();
    },
    async listbooths() {
      if (this.location == "namya.app" || this.location == "localhost:8080") {
        let response = await this.axios.get(
          "https://namya.ir/api/v1/businesses/booths" +
            "?page=" +
            this.current_page,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.token}`,
              "access-control-allow-methods":
                "PUT, GET, HEAD, POST, DELETE, OPTIONS",
              "access-control-allow-origin": "http://localhost:8080",
            },
          }
        );
        this.booths.push(...response.data.data);
        this.boothsSearch.push(...response.data.data);
        this.last_page = response.data.last_page;
        // localStorage.setItem("custom_id", self.$route.params.id);
      }
    },
    async listboothscategory() {
      let response = await this.axios.get(
        "https://namya.ir/api/v1/businesses/booths" +
          "?page=" +
          this.current_page +
          "&category=" +
          this.category,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.token}`,
          },
        }
      );
      if (this.category && response.data.data.length != 0) {
        this.booths = [];
      }
      this.booths.push(...response.data.data);
      this.last_page = response.data.last_page;
    },
    async listboothssort() {
      this.overlay = true;
      let response = await this.axios.get(
        "https://namya.ir/api/v1/businesses/booths" +
          "?page=" +
          this.current_page +
          "&sort=" +
          this.sort,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.token}`,
          },
        }
      );
      if (this.sort && response.data.data.length != 0) {
        this.booths = [];
      }
      this.booths.push(...response.data.data);
      this.last_page = response.data.last_page;
      setTimeout(() => {
        this.overlay = false;
      }, 2000);
    },
    async listboothssearch($event) {
      if ($event.length > 2) {
        let response = await this.axios.get(
          "https://namya.ir/api/v1/businesses/booths" +
            "?page=" +
            this.current_page +
            "&search=" +
            this.search,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.token}`,
            },
          }
        );
        if (this.search && response.data.data.length != 0) {
          this.booths = [];
        }
        this.overlay = true;
        this.booths.push(...response.data.data);
        this.last_page = response.data.last_page;
        setTimeout(() => {
          this.overlay = false;
        }, 2000);
      } else if ($event == "" && this.booths.length < 20) {
        this.booths = [];
        this.booths = this.boothsSearch;
      }
    },
    boothredirect(booths) {
      this.ID = booths.id;
      this.$router
        .push({
          name: "customertemplate",
          params: { ID: this.ID },
        })
        .catch();
      // let Return = null;
      // Return = {
      //   ID: this.ID,
      // };
      // this.$emit("ID", Return);
      // console.warn("ID", Return);
    },
    handleScrolledBottom(isVisible) {
      if (!isVisible) {
        return;
      }
      if (this.current_page >= this.last_page) {
        return;
      }
      if (this.current_page < 4) {
        this.current_page++;
        this.overlay = !this.overlay;
        this.listbooths();
      }
    },
    RouterToLocal(booth) {
      localStorage.setItem("custom_id", booth.id);
    },
    async follow(booth) {
      var self = this;
      this.form.business = booth.id;
      let response = await self.axios.post(
        "https://namya.ir/api/v1/businesses/follow",
        this.form,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.token}`,
          },
        }
      );
      booth.isFollow = response.data.success;
    },
    async unfollow(booth) {
      var self = this;
      this.form.business = booth.id;
      let response = await self.axios.post(
        "https://namya.ir/api/v1/businesses/unfollow",
        this.form,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.token}`,
          },
        }
      );
      booth.isFollow =
        response.data.success == true ? (booth.isFollow = false) : "";
    },
    async clicksort(sort) {
      if (sort) {
        if (sort == "مرتبط ترین") {
          this.sort = "defualt";
          this.$nextTick(() => this.$root.$refs.A.listboothssort());
        } else if (sort == "بالاترین رتبه") {
          this.sortclick = "rank";
          this.$nextTick(() => this.$root.$refs.A.listboothssort());
        } else if (sort == "جدیدترین") {
          this.sort = "newest";
          this.$nextTick(() => this.$root.$refs.A.listboothssort());
        } else if (sort == "بیشترین بازدید") {
          this.sort = "view";
          this.$nextTick(() => this.$root.$refs.A.listboothssort());
        } else if (sort == "بالاترین امتیاز") {
          this.sort = "rank";
          this.$nextTick(() => this.$root.$refs.A.listboothssort());
        } else if (sort == "نزدیک ترین") {
          this.sort = "near";
          this.$nextTick(() => this.$root.$refs.A.listboothssort());
        }
      }
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("click");
        }
      },
    },
  },
  created() {
    this.RedirectDomain();
    this.listbooths();
    this.$root.$refs.A = this;
    localStorage.removeItem("ID");
  },
};
</script>

<style lang="css" scoped>
.v-application .text-subtitle-1 {
  font-family: IRANSansX !important;
}
/* .v-card__text {
  padding: 10px !important;
} */
.v-card__subtitle,
.v-card__text,
.v-card__title {
  padding: 5px 20px 5px 20px;
}
.v-card__subtitle,
.v-card__text,
.v-card__title {
  justify-content: center !important;
}
.justify {
  justify-content: center !important;
}
.top-avatar {
  margin-top: -50px;
}
.v-card__title {
  font-weight: 200;
}
.v-card__subtitle {
  font-weight: 200;
}
.v-application .success[type="button"] {
  background-color: #888888 !important;
  border-color: #ffffff !important;
  /* border: 2px solid; */
}
.v-application .success[type="button"]:hover {
  background-color: #3eaf1f !important;
  border-color: #ffffff !important;
  /* border: 2px solid; */
}
.v-application .success[id="mobile"] {
  background-color: #888888 !important;
  border-color: #ffffff !important;
  /* border: 2px solid; */
}
.v-application .success[id="mobile"]:hover {
  background-color: #3eaf1f !important;
  border-color: #ffffff !important;
  /* border: 2px solid; */
}
* >>> .v-speed-dial--direction-top .v-speed-dial__list {
  flex-direction: column-reverse;
  bottom: 60% !important;
  left: -17px !important;
}
.v-speed-dial__list .v-btn {
  margin: 3px;
}
.rounded {
  border-radius: 10px !important;
}
.img-wrapper {
  width: 400px;
  height: 400px;
  overflow: hidden;
}

.inner-img {
  transition: 0.4s;
}

.inner-img:hover {
  transform: scale(1.1);
}

/* Other styling elements, that are not necessary for the example */

.img-wrapper {
  display: inline-block;
  box-sizing: border-box;
}
.v-card__title {
  font-size: 0.8rem;
}
.blobs-wrapper {
  position: fixed;
  z-index: 999999;
  top: -55px;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  display: flex;
  text-align: center;
  margin: 0 auto;
  flex-direction: column;
  justify-content: center;
}
.loader-blob {
  background: url(@/assets/images/logo/namya_logo.png);
  background-repeat: no-repeat;
  width: 60%;
  height: 100%;
  text-align: center;
  display: block;
  margin: auto;
  position: relative;
  vertical-align: middle;
}
.loader-blob,
.loader-blob:before,
.loader-blob:after {
  animation: 1.5s infinite ease-in-out;
  -o-animation: 1.5s infinite ease-in-out;
  -ms-animation: 1.5s infinite ease-in-out;
  -webkit-animation: 1.5s infinite ease-in-out;
  -moz-animation: 1.5s infinite ease-in-out;
}
.loader-blob:before,
.loader-blob:after {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.loader-blob {
  animation-name: loader-blob;
  -o-animation-name: loader-blob;
  -ms-animation-name: loader-blob;
  -webkit-animation-name: loader-blob;
  -moz-animation-name: loader-blob;
}
@keyframes loader-blob {
  from {
    transform: scale(0);
    opacity: 1;
  }
  to {
    transform: scale(0.4);
    opacity: 0;
  }
}
@-o-keyframes loader-blob {
  from {
    -o-transform: scale(0);
    opacity: 1;
  }
  to {
    -o-transform: scale(0.4);
    opacity: 0;
  }
}
@-ms-keyframes loader-blob {
  from {
    -ms-transform: scale(0);
    opacity: 1;
  }
  to {
    -ms-transform: scale(0.4);
    opacity: 0;
  }
}
@-webkit-keyframes loader-blob {
  from {
    -webkit-transform: scale(0);
    opacity: 1;
  }
  to {
    -webkit-transform: scale(0.4);
    opacity: 0;
  }
}
@-moz-keyframes loader-blob {
  from {
    -moz-transform: scale(0);
    opacity: 1;
  }
  to {
    -moz-transform: scale(0.4);
    opacity: 0;
  }
}
.v-sheet.v-card--hover {
  cursor: default;
  transition: box-shadow 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}
h4 {
  font-weight: 200;
  margin: 8px;
}
* >>> .v-chip__content {
  color: #868686;
  font-weight: 600;
  white-space: nowrap;
}
@media (min-width: 900px) {
  .show {
    display: none;
  }
}
</style>
